<!-- create-Ad -->
<div routerLink="/entry/create"
  class="flex flex-row gap-2 h-full w-[187px] text-sm font-medium cursor-pointer items-center justify-center"
  [class]="activateCreateAdMenu()? 'text-kaz-black border-b-[2px] border-kaz-black':'text-[#A8A8A8] border-b border-[#D2D2D2]'">
  <fa-icon icon="tag" size="lg"></fa-icon>
  <span>Anzeige aufgeben</span>
</div>
<!-- Account -->
<div routerLink="/profile"
  class="flex flex-row gap-2 h-full w-[187px] text-sm font-medium cursor-pointer items-center justify-center"
  [class]="activateAccountMenu()? 'text-kaz-black border-b-[2px] border-kaz-black':'text-[#A8A8A8] border-b border-[#D2D2D2]'">
  <fa-icon icon="user" size="lg"></fa-icon>
  <span>Konto</span>
</div>
<!-- Rechte Seite (vom Frame) -->
<ng-content></ng-content>
